import dashboardIcon from '../../assets/icons/grey/dashboard_grey.svg';
import dashboardActiveIcon from '../../assets/icons/blue/dashboard_blue.svg';
import coreDataIcon from '../../assets/icons/grey/basedata_grey.svg';
import coreDataActiveIcon from '../../assets/icons/blue/basedata_blue.svg';
import filesIcon from '../../assets/icons/grey/files_grey.svg';
import filesActiveIcon from '../../assets/icons/blue/files_blue.svg';
import ordersIcon from '../../assets/icons/grey/Incoming_data_grey.svg';
import ordersActiveIcon from '../../assets/icons/blue/Incoming_data_blue.svg';
import statisticsIcon from '../../assets/icons/grey/statistics_grey.svg';
import statisticsActiveIcon from '../../assets/icons/blue/statistics_blue.svg';
import employeesIcon from '../../assets/icons/grey/Employees_grey.svg';
import employeesActiveIcon from '../../assets/icons/blue/Employees_blue.svg';
import importDataIcon from '../../assets/icons/grey/import_grey.svg';
import importDataActiveIcon from '../../assets/icons/blue/import_blue.svg';
import exportDataIcon from '../../assets/icons/grey/export_grey.svg';
import exportDataActiveIcon from '../../assets/icons/blue/export_blue.svg';
import administrationIcon from '../../assets/icons/grey/Administration_grey.svg';
import administrationActiveIcon from '../../assets/icons/blue/Administration_blue.svg';
import administrationBlockIcon from '../../assets/icons/blue/administration_block.svg';
import teamGreyIcon from '../../assets/icons/grey/team_grey.svg';
import teamBlueActiveIcon from '../../assets/icons/blue/team_blue.svg';
import apiIcon from '../../assets/icons/grey/api_grey.svg';
import apiActiveIcon from '../../assets/icons/blue/api_blue.svg';
import goalIcon from '../../assets/icons/grey/goal_grey.svg';
import goalActiveIcon from '../../assets/icons/blue/goal_blue.svg';
import metricsIcon from '../../assets/icons/grey/metrics_grey.svg';
import metricsActiveIcon from '../../assets/icons/blue/metrics_blue.svg';
import listIcon from '../../assets/icons/grey/list_grey.svg';
import listActiveIcon from '../../assets/icons/blue/list_blue.svg';
import partsIcon from '../../assets/icons/grey/parts_grey.svg';
import partsActiveIcon from '../../assets/icons/blue/parts_blue.svg';
import articlesIcon from '../../assets/icons/grey/articles_grey.svg';
import articlesActiveIcon from '../../assets/icons/blue/articles_blue.svg';
import caseTemplateIcon from '../../assets/icons/grey/case_template_grey.svg';
import caseTemplateActiveIcon from '../../assets/icons/blue/case_template_blue.svg';
import caseIcon from '../../assets/icons/grey/case_template_icon_grey.svg';
import caseActiveIcon from '../../assets/icons/blue/case_template_icon_blue.svg';
import suppliersIcon from '../../assets/icons/grey/suppliers_grey.svg';
import suppliersActiveIcon from '../../assets/icons/blue/suppliers_blue.svg';
import cameraIcon from '../../assets/icons/grey/camera_grey.svg';
import cameraActiveIcon from '../../assets/icons/blue/camera_blue.svg';
import incomingDataIcon from '../../assets/icons/grey/Incoming_data_grey.svg';
import incomingDataActiveIcon from '../../assets/icons/blue/Incoming_data_blue.svg';

export default [
  {
    name: '',
    items: [
      {
        name: 'dashboard',
        titleKey: 'dashboard',
        icon: dashboardIcon,
        activeIcon: dashboardActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/dashboard',
        roles: '*',
      },
      {
        titleKey: 'sales_catalogues',
        roles: '*',
        name: 'sales-catalogues',
        icon: filesIcon,
        activeIcon: filesActiveIcon,
        isCollapsed: false,
        isActive: false,
        route: '/sales-catalogues',
      },
      {
        name: 'orderintake',
        titleKey: 'order_intake',
        icon: ordersIcon,
        activeIcon: ordersActiveIcon,
        isCollapsed: false,
        isActive: false,
        submenus: [],
        roles: '*',
        route: '/orders',
      },
      {
        name: 'import',
        titleKey: 'import',
        route: '/import',
        icon: importDataIcon,
        activeIcon: importDataActiveIcon,
        isActive: false,
        roles: '*',
      },
      {
        name: 'export',
        titleKey: 'export',
        route: '/export',
        icon: exportDataIcon,
        activeIcon: exportDataActiveIcon,
        isActive: false,
        roles: '*',
      },
      {
        name: 'statistics',
        titleKey: 'statistics',
        icon: statisticsIcon,
        activeIcon: statisticsActiveIcon,
        isCollapsed: false,
        isActive: false,
        submenus: [],
        roles: '*',
        route: '/statistics',
      },
    ],
  },
  {
    name: 'base_data',
    icon: coreDataIcon,
    // titleKey: 'base_data',
    // activeIcon: coreDataActiveIcon,
    // isCollapsed: false,
    // isActive: false,
    // roles: '*',
    items: [
      {
        name: 'customers',
        icon: teamGreyIcon,
        activeIcon: teamBlueActiveIcon,
        titleKey: 'customers',
        route: '/customers',
        isActive: false,
        roles: '*',
      },
      {
        name: 'customer_statistics',
        icon: statisticsIcon,
        activeIcon: statisticsActiveIcon,
        titleKey: 'customer_statistics',
        route: '/customer-statistics',
        isActive: false,
        roles: '*',
      },
      {
        name: 'conditions',
        icon: apiIcon,
        activeIcon: apiActiveIcon,
        titleKey: 'conditions',
        route: '/conditions',
        isActive: false,
        roles: '*',
      },
      {
        name: 'articles',
        icon: articlesIcon,
        activeIcon: articlesActiveIcon,
        titleKey: 'article',
        route: '/articles',
        isActive: false,
        roles: '*',
      },
      {
        name: 'article_descriptions',
        icon: caseTemplateIcon,
        activeIcon: caseTemplateActiveIcon,
        titleKey: 'article_descriptions',
        route: '/article-descriptions',
        isActive: false,
        roles: '*',
      },
      {
        name: 'article_keywords',
        icon: caseIcon,
        activeIcon: caseActiveIcon,
        titleKey: 'article_keywords',
        route: '/article-keywords',
        isActive: false,
        roles: '*',
      },
      {
        name: 'article_keyword_structures',
        icon: suppliersIcon,
        activeIcon: suppliersActiveIcon,
        titleKey: 'article_keyword_structures',
        route: '/article-keyword-structure',
        isActive: false,
        roles: '*',
      },
      {
        name: 'article_keyword_assignments',
        icon: incomingDataIcon,
        activeIcon: incomingDataActiveIcon,
        titleKey: 'article_keyword_assignments',
        route: '/article-keyword-assignment',
        isActive: false,
        roles: '*',
      },
      {
        name: 'article_pictures',
        icon: cameraIcon,
        activeIcon: cameraActiveIcon,
        titleKey: 'article_pictures',
        route: '/article-pictures',
        isActive: false,
        roles: '*',
      },
      {
        name: 'article_alternatives',
        icon: filesIcon,
        activeIcon: filesActiveIcon,
        titleKey: 'article_alternatives',
        route: '/article-alternatives',
        isActive: false,
        roles: '*',
      },
      {
        name: 'appointment_grid',
        icon: goalIcon,
        activeIcon: goalActiveIcon,
        titleKey: 'appointment_grid',
        route: '/appointment-grid',
        isActive: false,
        roles: '*',
      },
      {
        name: 'quantity_scale',
        icon: metricsIcon,
        activeIcon: metricsActiveIcon,
        titleKey: 'quantity_scale',
        route: '/quantity-scale',
        isActive: false,
        roles: '*',
      },
      {
        name: 'pricelist',
        icon: listIcon,
        activeIcon: listActiveIcon,
        titleKey: 'price_list',
        route: '/pricelist',
        isActive: false,
        roles: '*',
      },
      {
        name: 'stocks',
        icon: partsIcon,
        activeIcon: partsActiveIcon,
        titleKey: 'stocks',
        route: '/stocks',
        isActive: false,
        roles: '*',
      },
    ],
  },
  {
    name: 'Administration',
    icon: administrationBlockIcon,
    items: [
      {
        name: 'employees',
        titleKey: 'users_and_devices',
        route: '/employees',
        icon: employeesIcon,
        activeIcon: employeesActiveIcon,
        isActive: false,
        roles: '*',
      },
      {
        name: 'settings',
        titleKey: 'settings',
        icon: administrationIcon,
        activeIcon: administrationActiveIcon,
        isCollapsed: false,
        isActive: false,
        roles: '*',
        route: '/system',
      },
    ],
  },
];
